import { LOCATION_CHANGE } from 'connected-react-router';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { ROUTES } from '@shared/constants';
import { clearUiState as clearForgotPasswordUiState } from './ForgotPassword/actions';
import { clearUiState as clearResetPasswordUiState } from './ResetPassword/actions';
import { clearUiState as clearSignInUiState } from './SignIn/actions';

const AUTH_ROUTES = new Set([
  ROUTES.SIGN_IN,
  ROUTES.SIGN_UP,
  ROUTES.COMPLETE_SIGN_UP,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.VERIFY_EMAIL_SENT,
  ROUTES.MFA_VERIFICATION,
]);

const normalizePathname = (pathname = '') => {
  const clean = String(pathname || '').split('?')[0].split('#')[0].trim();
  if (!clean) return '';
  if (clean.length > 1 && clean.endsWith('/')) return clean.slice(0, -1);
  return clean;
};

const getPathnameFromLocationChange = (action) => (
  normalizePathname(action?.payload?.location?.pathname || action?.payload?.pathname || '')
);

const isAuthRoute = (pathname) => {
  if (!pathname) return false;
  if (AUTH_ROUTES.has(pathname)) return true;

  // Support nested auth routes in case route params/subpaths are added later.
  return Array.from(AUTH_ROUTES).some((route) => pathname.startsWith(`${route}/`));
};

function* resetAuthUiOnNavigation(action) {
  const pathname = getPathnameFromLocationChange(action);
  if (!isAuthRoute(pathname)) return;

  yield all([
    put(clearSignInUiState()),
    put(clearForgotPasswordUiState()),
    put(clearResetPasswordUiState()),
  ]);
}

function* watchAuthNavigationUiReset() {
  yield takeLatest(LOCATION_CHANGE, resetAuthUiOnNavigation);
}

export default function* authUiResetOnNavigationSaga() {
  yield fork(watchAuthNavigationUiReset);
}
